<div class="container-fluid justify-content-center section my-3" [ngClass]="loggedIn ? '' : 'disabled-background'">
  <div class="d-flex flex-column">
    <div class="mt-3 title">Book a Midwife</div>
    <div class="mt-2 mb-2 text-content">Nam nec arcu quis tellus efficitur hendrerit. Suspendisse elit elit, luctus vel
      feli consectetur suscipit
      sapien.</div>
    <div class="mt-2 mb-2 text-label">Write your message</div>
    <textarea [disabled]="!loggedIn" class="text-content py-1 px-2" placeholder="Write your message"
      [(ngModel)]="message"></textarea>
    <button [disabled]="!loggedIn || message.length < 10" [ngClass]="loggedIn ? '' : 'btn-disabled'"
      class="btn btn-theme mt-3 mb-3" data-toggle="modal" data-target="#request-sent-modal" (click)="bookAppointment()"
      type="button">
      BOOK APPOINTMENT
    </button>
  </div>
</div>